module.exports = __webpack_public_path__ + "static/media/chandelier.0a693ead.png";